export { default } from './InstallationItemActionsBarConnector';
